import actions from "./actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  isFetching: false,
  successMessage: "",
  errorMessage: "",
  actionType: "",
  status_code: 0,
  loginType: "",
});

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOGIN_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.LOGIN_REQUEST,
      });
    case actions.LOGIN_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.LOGIN_SUCCESS,
        successMessage: action.message,
        loginType: action.loginType,
        status_code: action.status_code,
      });
    case actions.LOGIN_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.LOGIN_ERROR,
        errorMessage: action.error,
      });

    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: "",
        successMessage: "",
        errorMessage: "",
        isFetching: false,
      });
    default:
      return state;
  }
}
